module.exports = __webpack_public_path__ + "static/img/GettyImages-499134783.c065832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/GettyImages-499134783.jpg
// module id = neHS
// module chunks = 0